import { useEffect, useState } from "react";
import "./Project.style.css";
import ProjectCard from "./ProjectCard.component";
import Loader from "../Loader/Loader.component";
const Projects = () => {
  const [fetching, setFetching] = useState();
  // Keep fetchet project data from DB
  const [data, setData] = useState([]);
  // Push data to this array after img buffer is converted to base64
  // and new object is created with all informations
  const projects = [];

  // Fetch projects from DB
  const fetchProjects = async () => {
    setFetching(true);
    await fetch("https://my-portfolio-psi-self.vercel.app/project")
      .then((response) => response.json())
      .then((data) => {
        setData(data);
      })
      .catch((e) => console.log(e))
      .finally(() => setFetching(false));
  };

  // Map through project data
  // Convert Buffer image to Base64
  // Create new object with all infomations and push to project array
  data.map((item) => {
    const img = new Buffer.from(item.projectImg).toString("base64");
    const data = {
      _id: item._id,
      img,
      description: item.description,
      url: item.url,
    };
    return projects.push(data);
  });

  // Fetch Project on mount
  useEffect(() => {
    fetchProjects();
  }, []);

  if (fetching) {
    return (
      <section id="projects" className="section-title section-container projects-container">
        <div className="projects-content">
          <h2>Projects</h2>
          <div className="div-project-cards">
            <Loader />
            <Loader />
            <Loader />
            <Loader />
            <Loader />
            <Loader />
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="projects" className="section-title section-container projects-container">
      <div className="projects-content">
        <h2>Projects</h2>
        <div className="div-project-cards">
          {projects.map((project) => (
            <ProjectCard
              img={project.img}
              description={project.description}
              url={project.url}
              key={project._id}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
